module.exports = __webpack_public_path__ + "static/media/campbell1.5510b150.jpg";